import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import CrewForm from '../Form';
import { createCrew } from '@resources/Crew/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { createCrew, visible, onCancel, module } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createCrew(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.crew.create',
						defaultMessage:
							'A new Crew has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.crew',
					defaultMessage: 'Create Crew',
				})}
			</Title>
			<CrewForm onSubmit={handleSubmit} {...props} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	crews,
	modules,
	event,
	facility,
	ministry,
	cellGroup,
	organization,
}) => {
	return {
		crews,
		ministry,
		facility,
		modules,
		event,
		cellGroup,
		organization,
	};
};

export default connect(mapStateToProps, {
	createCrew,
	fetchModulesBySubmoduleCode,
})(Create);
